import { Stack } from '@mui/material';
import React, { useState } from 'react';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import ErrorBoundary from '../../../components/material-ui/error_boundary/ErrorBoundary';
import ReportRefcodeTable from './ReportRefcodeTable';
import ReportRefcodeFilter from './ReportRefcodeFilter';

export default function ReportRefcode() {
  const [loader, setLoader] = useState(false);
  const [empty, setEmpty] = useState(false);

  return (
    <CusPageCardContainer title={'Refcode reports'}>
      <Stack gap={3}>
        <ErrorBoundary>
          <ReportRefcodeFilter setLoader={setLoader} setEmpty={setEmpty} />
        </ErrorBoundary>
        <ErrorBoundary>
          <ReportRefcodeTable loader={loader} empty={empty} />
        </ErrorBoundary>
      </Stack>
    </CusPageCardContainer>
  );
}
